/**
 * Facets Fetcher
 * Fetch available filter options
 */

import { getIndex } from './client.js';
import { buildFiltersWithout } from '../filters/filter-builder.js';
import { getGeoSearchParams } from '../filters/geo-params.js';
import { state } from '../core/state.js';

/**
 * Fetch full brands, feeCodes, and skills facet lists in a single query.
 * Excludes brand, types, and skills filters so the lists are never narrowed by current selection.
 * @returns {Promise<{brands: Object, feeCodes: Object, skills: Object}>}
 */
export function getAvailableFacets() {
  const index = getIndex();
  const filters = buildFiltersWithout(['brand', 'types', 'skills', 'live']);
  const geoParams = getGeoSearchParams();
  return index
    .search('', {
      filters,
      facets: ['brands', 'feeCodes', 'skills'],
      hitsPerPage: 0,
      ...geoParams,
    })
    .then(({ facets }) => ({
      brands: facets?.brands || {},
      feeCodes: facets?.feeCodes || {},
      skills: facets?.skills || {},
    }))
    .catch(() => ({
      brands: state.facets.brands || {},
      feeCodes: state.facets.feeCodes || {},
      skills: state.facets.skills || {},
    }));
}

console.log('📦 Facets fetcher module loaded');
